// @mui material components
import {
  Snackbar,
  Alert,
  // Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Grid,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

import { toPng } from "html-to-image";
import QRCode from "react-qr-code";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function AffiliateLinkPage() {
  const pageTitle = "Affiliate Link";
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const qrCodeRef = useRef(null);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [openCopySnackBar, setOpenSnackBar] = useState(false);
  async function copy(voucher) {
    try {
      await navigator.clipboard.writeText(voucher);
      setOpenSnackBar(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  const [affiliateLink, setAffiliateLink] = useState(null);
  const [productLinks, setProductLinks] = useState([]);
  const [selectedLink, setSelectedLink] = useState(null);
  const [openQRCodeDialog, setOpenQRCodeDialog] = useState(false);

  function downloadQRCode() {
    toPng(qrCodeRef.current)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        // link.download = `${fileName}.png`;
        link.download = `qr_link.png`;
        link.click();
      })
      .catch((error) => {
        console.error("Error generating QR code:", error);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/campaign/${ref}/links.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setAffiliateLink(result.data.data.affiliate_link);
            setProductLinks(result.data.data.affiliate_link.products);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function shareLink(platform, afLink) {
    const link = afLink.paylink;
    let msg = `Buy now using my Affiliate Link.`;
    msg = `*${encodeURIComponent(afLink.campaign)}*%0a${encodeURIComponent(
      msg
    )}%0a%0a${encodeURIComponent(link)}%0a%0a*Powered by Laddar Africa*`;
    let url = "";
    if (platform === "whatsapp") {
      url = `whatsapp://send?text=${msg}`;
    } else {
      url = `https://t.me/share/url?url=${msg}`;
    }
    window.open(url, "_blank");
  }

  function shareLinkProduct(platform, prdct) {
    const plink = prdct.link;
    let msg = `${
      prdct.price !== null && prdct.price
        ? `%0a*${prdct.currency}${(prdct.price / 100).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}*%0a`
        : ""
    }`;
    msg = `${encodeURIComponent(prdct.title)}.${msg}%0a*Buy Now*%0a${encodeURIComponent(plink)}`;
    let url = "";
    if (platform === "whatsapp") {
      url = `whatsapp://send?text=${msg}`;
    } else {
      url = `https://t.me/share/url?url=${msg}`;
    }
    window.open(url, "_blank");
  }

  async function webShare(title, text, url, imageUrl = null) {
    if (navigator.share === "undefined") {
      alert("Your browser does not support this feature.");
      return;
    }

    imageUrl = null;
    let shareObject = {};
    if (imageUrl !== null) {
      setShowLoading(true);
      try {
        const image = await fetch(imageUrl, { cache: "no-cache" });
        console.log(image);
        const blobData = await image.blob();
        console.log(blobData);
        const fileObj = new File([blobData], `product.jpg`, { type: blobData.type });

        // shareObject.files = [fileObj];
        text = `${text}. ${url}`;
        shareObject = {
          title: `${title}`,
          text: `${text}`,
          files: [fileObj],
          url: `${url}`,
        };
        setShowLoading(false);
      } catch (error) {
        setShowLoading(false);
        shareObject = {
          title: `${title}`,
          text: `${text}`,
          url: `${url}`,
        };
      }
    } else {
      shareObject = {
        title: `${title}`,
        text: `${text}`,
        url: `${url}`,
      };
    }

    try {
      navigator
        .share(shareObject)
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch((err) => {
          // Handle errors, if occurred
          console.log("Error while using Web share API:");
          console.log(err);
        });
    } catch (err) {
      console.error("Share failed:", err.message);
      alert("Your browser does not support this feature.");
    }
  }

  function shareWebProduct(prdct, imageUrl) {
    const plink = prdct.link;
    const msg = `Buy ${prdct.title} ${
      prdct.price !== null && prdct.price
        ? `at ${prdct.currency}${(prdct.price / 100).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : ""
    }. Click link for more info.`;

    webShare(prdct.title, msg, plink, imageUrl);
  }

  function shareWebCampaign(afLink) {
    const link = afLink.paylink;
    const msg = `Interested in ${afLink.campaign}? Buy now using my affiliate Link.`;
    webShare(afLink.campaign.title, msg, link);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        autoHideDuration={5000}
        onClose={() => setOpenSnackBar(false)}
        open={openCopySnackBar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Copied
        </Alert>
      </Snackbar>
      {selectedLink ? (
        <Dialog open={openQRCodeDialog}>
          <DialogTitle>
            <MDBox>QR Code</MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox p={2} ref={qrCodeRef}>
              <QRCode value={selectedLink} size={180} />
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenQRCodeDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                close
              </Icon>
            </MDButton>
            <MDButton
              onClick={() => downloadQRCode()}
              color="success"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                download
              </Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}

      <MDBox pt={3} pb={3}>
        {affiliateLink ? (
          <MDBox>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={3}>
                <MDBox align="justify">
                  <MDBox mt={-1}>
                    <MDTypography variant="button" color="info" fontWeight="light">
                      <img
                        src={`${AppConfig.api_media_url}${affiliateLink.account.icon}`}
                        alt=""
                        width="16px"
                      />
                      &nbsp; &nbsp;{affiliateLink.account.name}
                    </MDTypography>
                  </MDBox>
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="medium">
                      {affiliateLink.campaign}
                    </MDTypography>
                  </MDBox>
                  {/* <MDBox>
                    <MDTypography variant="text" fontWeight="light" fontSize={12}>
                      <a href={affiliateLink.paylink} target="_blank" rel="noreferrer">
                        {affiliateLink.paylink}
                      </a>
                    </MDTypography>
                  </MDBox> */}
                  <Divider />
                  <MDBox
                    ml={-1}
                    mt={0}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="start"
                  >
                    <a href={affiliateLink.paylink} target="_blank" rel="noreferrer">
                      <IconButton variant="outlined" color="dark">
                        <Icon>send</Icon>
                      </IconButton>
                    </a>
                    <IconButton
                      variant="outlined"
                      color="primary"
                      onClick={() => copy(affiliateLink.paylink)}
                    >
                      <Icon>copy</Icon>
                    </IconButton>

                    <IconButton
                      onClick={() => {
                        setSelectedLink(affiliateLink.paylink);
                        setOpenQRCodeDialog(true);
                      }}
                      color="info"
                    >
                      <Icon>qr_code</Icon>
                    </IconButton>
                    <IconButton onClick={() => shareLink("whatsapp", affiliateLink)}>
                      <WhatsAppIcon color="success">WhatsApp</WhatsAppIcon>
                    </IconButton>
                    <IconButton onClick={() => shareLink("telegram", affiliateLink)}>
                      <Icon color="info">telegram</Icon>
                    </IconButton>
                    <IconButton onClick={() => shareWebCampaign(affiliateLink)}>
                      <Icon color="dark">share</Icon>
                    </IconButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        ) : (
          <> </>
        )}
        <MDBox mt={5}>
          <MDBox px={3}>
            <MDTypography variant="subtitle2">Product Links</MDTypography>
          </MDBox>
          <MDBox mb={1}>
            <Divider />
          </MDBox>
          <List disablePadding>
            <Grid container spacing={3}>
              {productLinks.map((product) => (
                <Grid item xs={12} md={6} lg={6}>
                  <MDBox mb={1}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <ListItem key={product.reference} sx={{ py: 1, px: 0 }}>
                          <ListItemIcon
                            onClick={() => {
                              navigate(`/product-hub/${product.reference}`);
                            }}
                          >
                            <img
                              src={`${AppConfig.api_media_url}${product.image}`}
                              // alt={product.name}
                              alt=""
                              width="64px"
                            />
                          </ListItemIcon>
                          <ListItemText
                            sx={{ ml: 2 }}
                            primary={
                              <MDBox
                                onClick={() => {
                                  navigate(`/product-hub/${product.reference}`);
                                }}
                              >
                                <MDBox>
                                  <MDTypography variant="h6" fontSize={14} fontWeight="bold">
                                    {product.title}
                                  </MDTypography>
                                </MDBox>
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="light">
                                    {product.currency}
                                    {(product.price / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </MDBox>
                                <Divider />
                              </MDBox>
                            }
                            secondary={
                              <MDBox
                                ml={-1}
                                mt={1}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="start"
                              >
                                <a href={product.link} target="_blank" rel="noreferrer">
                                  <IconButton size="small" variant="outlined" color="dark">
                                    <Icon>send</Icon>
                                  </IconButton>
                                </a>
                                <IconButton
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  onClick={() => copy(product.link)}
                                >
                                  <Icon>copy</Icon>
                                </IconButton>
                                <IconButton
                                  onClick={() => {
                                    setSelectedLink(product.link);
                                    setOpenQRCodeDialog(true);
                                  }}
                                  color="info"
                                  size="small"
                                >
                                  <Icon>qr_code</Icon>
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() => shareLinkProduct("whatsapp", product)}
                                >
                                  <WhatsAppIcon color="success">WhatsApp</WhatsAppIcon>
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() => shareLinkProduct("telegram", product)}
                                >
                                  <Icon color="info">telegram</Icon>
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    shareWebProduct(
                                      product,
                                      `${AppConfig.api_cors_url}media/${product.image}`
                                    )
                                  }
                                >
                                  <Icon color="dark">share</Icon>
                                </IconButton>
                              </MDBox>
                            }
                          />
                        </ListItem>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              ))}
            </Grid>
          </List>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AffiliateLinkPage;
